import React from "react";

type FormattedDateProps = {
  value: string | Date;
  invalidText?: string; // texto opcional para cuando la fecha sea inválida
};

const FormattedDate: React.FC<FormattedDateProps> = ({ value, invalidText = "Fecha inválida" }) => {
  let date: Date;

  if (typeof value === "string") {
    // Limpiar si tiene fracción de segundos excesiva
    const cleaned = value.includes(".") ? value.split(".")[0] : value;
    date = new Date(cleaned);
  } else {
    date = value;
  }

  if (isNaN(date.getTime())) {
    return <span>{invalidText}</span>;
  }

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  return <span>{`${day}/${month}/${year}`}</span>;
};

export default FormattedDate;